import type { Tone } from "./tokens";

export interface Notification {
  readonly id: string;
  readonly tone: Tone;
  readonly title: string;
  readonly message?: string;
  readonly ts: string;
  readonly read: boolean;
}

export interface NotificationInput {
  readonly tone: Tone;
  readonly title: string;
  readonly message?: string;
  readonly ts?: string;
}

export interface NotificationStore {
  add(input: NotificationInput): Notification;
  list(): readonly Notification[];
  unreadCount(): number;
  markRead(id: string): void;
  markAllRead(): void;
  subscribe(listener: () => void): () => void;
}

export function createNotificationStore(seed: readonly Notification[] = []): NotificationStore {
  let items: Notification[] = [...seed];
  let seq = 0;
  const listeners = new Set<() => void>();
  const emit = (): void => {
    for (const l of listeners) l();
  };
  return {
    add(input) {
      seq += 1;
      const n: Notification = {
        id: "n-" + seq,
        tone: input.tone,
        title: input.title,
        ...(input.message !== undefined ? { message: input.message } : {}),
        ts: input.ts ?? "",
        read: false,
      };
      items = [n, ...items];
      emit();
      return n;
    },
    list() {
      return items;
    },
    unreadCount() {
      return items.filter((n) => !n.read).length;
    },
    markRead(id) {
      items = items.map((n) => (n.id === id ? { ...n, read: true } : n));
      emit();
    },
    markAllRead() {
      items = items.map((n) => (n.read ? n : { ...n, read: true }));
      emit();
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

// アプリ単一インスタンス。モックのサンプル通知を初期投入(トースト/ベルが共有)。
export const notifications: NotificationStore = createNotificationStore([
  { id: "seed-1", tone: "success", title: "週次監査が完了しました", message: "Salesforce 監査の自動実行が完了しました。", ts: "2026-06-09 01:30", read: false },
  { id: "seed-2", tone: "info", title: "設定スナップショットを取得しました", message: "本日分の自動スナップショットを保存しました。", ts: "2026-06-09 00:10", read: true },
]);
